import { render, staticRenderFns } from "./index.vue?vue&type=template&id=80319cc0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80319cc0')) {
      api.createRecord('80319cc0', component.options)
    } else {
      api.reload('80319cc0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=80319cc0", function () {
      api.rerender('80319cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/index.vue"
export default component.exports